import { LngLat, Map } from 'maplibre-gl';
import {MapContent} from '../MapContent';
import {MapTools} from '../../../../tools/MapTools';
import { Protocol } from 'pmtiles';

export class AddressLookupEmptyMapContent implements MapContent {

  private map: Map = null;

  private readonly mapClickListener: any;

  constructor(
    private mapClicked: (markerId: LngLat) => void,
  ) {
    this.mapClickListener = (e) => {
      if (MapTools.checkPropagation(e)) {
        return;
      }
      this.mapClicked(e.lngLat);
    };
  }

  load(map: Map, protocol: Protocol, zoomToFeatures: boolean) {
    this.map = map;
    this.map.on('click', this.mapClickListener);
  }

  unload() {
    this.map.off('click', this.mapClickListener);
    this.map = null;
  }
}
